export default __webpack_public_path__ + "locales/sr-Latn-RS/Files.json?hash=ca0ab770c76d05c347055a6d365f22d0";